import { MenuSub } from '@/components/menu';
import { MegaMenuSubDropdown } from './components';
const MegaMenuMarketing = items => {
  const marketingItem = items.find(
    item => item.title === 'Marketing ' || item.title === 'Marketing'
  );

  return <MenuSub className="menu-default py-2.5 lg:w-[225px]">
    {marketingItem.children && MegaMenuSubDropdown(marketingItem.children)}
  </MenuSub>;
};
export { MegaMenuMarketing };